import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/home/index.vue";
import { xiyouRoutes } from "@/views/xiyou/route";

const routes: Array<RouteRecordRaw> = [
  {
    // 官网首页：根路径已交给 xiyou 模块，这里改为 /home（name 不变，按 name 跳转的链接无需修改）
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/articles",
    name: "Articles",
    component: () =>
      import(/* webpackChunkName: "articles" */ "@/views/articles/index.vue"),
  },
  {
    path: "/contribute",
    name: "Contribute",
    component: () =>
      import(
        /* webpackChunkName: "contribute" */ "@/views/contribute/index.vue"
      ),
  },
  {
    path: "/store",
    name: "Store",
    component: () =>
      import(/* webpackChunkName: "store" */ "@/views/store/index.vue"),
  },
  {
    path: "/recharge",
    name: "Recharge",
    component: () =>
      import(/* webpackChunkName: "recharge" */ "@/views/recharge/index.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/about/index.vue"),
  },
  // xiyou 模块挂在站点根路径（/），并接管未匹配路径的兜底
  ...xiyouRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
